
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_f8g6q_80voo_145",
  "embedded": "awsui_embedded_f8g6q_80voo_177",
  "tokens": "awsui_tokens_f8g6q_80voo_210"
};
  